// src/render/sectionBuilder.ts
import { renderSection as doRenderSection } from "./renderSection";
import { getBaseUrl } from "../utils/config";
import { log } from "../utils/debug";
import type { SectionAttrs } from "../types";

const BASE_URL = getBaseUrl();

export function buildSection(
  attrs: SectionAttrs,
  content: string,
  isFirstSection: boolean,
  baseUrl: string = BASE_URL
): HTMLElement {
  // --- setup ---
  const counter = ((buildSection as any).counter || 0);
  (buildSection as any).counter = counter + 1;

  log("[sectionBuilder] Building section", {
    attrs,
    isFirstSection,
    index: counter
  });

  const section = document.createElement("section");
  section.dataset.sectionIndex = String(counter);
  section.className = "relative min-h-screen bg-cover bg-center overflow-hidden flex flex-col";
  section.style.alignItems = "stretch";

  // keep a reference to attrs for downstream utilities
  (section as any).attrs = attrs;

  // Prefer reliable orientation detection
  const isVertical = window.matchMedia?.("(orientation: portrait)").matches ?? (window.innerHeight > window.innerWidth);

  // Simple tags for downstream diagnostics/logic
  section.dataset.mode = "content";
  section.dataset.orientation = isVertical ? "portrait" : "landscape";
  if (isFirstSection) section.dataset.isFirst = "1";
  section.id = `section-${counter}`;

  // Unified render path
  doRenderSection(section, attrs, content, baseUrl);

  log("[sectionBuilder] Rendering section", {
    attrs,
    isFirstSection,
    index: counter
  });

  // NOTE: Inline and overlay images are now handled in renderSection.ts before initHiddenState().

  return section;
}

export function renderSection(
  attrs: SectionAttrs,
  content: string,
  isFirstSection: boolean,
  baseUrl: string = BASE_URL
): HTMLElement {
  return buildSection(attrs, content, isFirstSection, baseUrl);
}

(buildSection as any).counter = 0;